
import { Component, Prop, Vue } from 'vue-property-decorator';
import { NuxtError } from '@nuxt/types';
import { ThemeName } from '~/store/types';
import FullScreenError from '~/components/UIComponents/FullScreenError.vue';
import ThemeProvider from '~/components/ThemeProvider.vue';

export interface IError extends Error {
  code?: number;
}

@Component({
  components: { FullScreenError, ThemeProvider },
  meta: {
    theme: ThemeName.DARK,
  },
})
export default class ErrorPage extends Vue {
  @Prop(Object)
  readonly error!: NuxtError;

  theme = ThemeName.DARK;

  get title() {
    const i18nPath = `pages.error.title.${this.error.statusCode || 'default'}`;
    return this.$te(i18nPath)
      ? this.$t(i18nPath)
      : this.$t('pages.error.title.default');
  }

  get message() {
    const i18nPath = `pages.error.message.${
      this.error.statusCode || 'default'
    }`;
    return this.$te(i18nPath)
      ? this.$t(i18nPath)
      : this.$t('pages.error.message.default');
  }
}
